import {makeAutoObservable} from 'mobx';
import {fromPromise, IPromiseBasedObservable} from 'mobx-utils';
import {getSiteList} from '../api/getSiteList.ts';
import {SiteType} from '@wp-content-publisher/typings-lib/dist/src/server/types/site.ts';
import {removeSite} from '../api/removeSite.ts';

class SiteListStore {

    list?: IPromiseBasedObservable<SiteType[]>;

    constructor() {
        makeAutoObservable(this);
    }

    getListAction = () => {
        this.list = fromPromise(getSiteList());
    }

    onDelete = (id: number) => {
        fromPromise(removeSite(id))
    }
}

const siteListStore = new SiteListStore();
export {siteListStore};